import { Component, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-chart-yzoom',
    templateUrl: './chart-yzoom.component.html',
    styleUrls: ['./chart-yzoom.component.scss'],
    standalone: false
})
export class ChartYzoomComponent {
    @Input() paramDtls: any;
    @Output() yzoomSubmit: EventEmitter<object> = new EventEmitter();
    yzoommax = new UntypedFormControl('');
    yzoommin = new UntypedFormControl('');
    constructor() { }

    zoomValueChange() {
        this.yzoomSubmit.emit({ action: 'change', max: null, min: null });
    }

    zoomSubmit(type: any, event?: any) {
        if (type === 'set') {
            this.yzoomSubmit.emit({ action: type, max: this.yzoommax.value, min: this.yzoommin.value });
        } else {
            if (!this.yzoommax.value && !this.yzoommin.value) {
                event.hide();
            }
            this.yzoommax.setValue('');
            this.yzoommin.setValue('');
            this.yzoomSubmit.emit({ action: type, max: null, min: null });
        }
    }
}
